import React from 'react';
import styled from '@benzinga/themetron';
import { CallToActionProps } from '@benzinga/ui';
const MoneyHeaderLayout1 = React.lazy(() =>
  import('./MoneyHeaderLayout1').then(module => ({ default: module.MoneyHeaderLayout1 })),
);
const MoneyHeaderLayout2 = React.lazy(() =>
  import('./MoneyHeaderLayout2').then(module => ({ default: module.MoneyHeaderLayout2 })),
);
const MoneyHeaderLayout3 = React.lazy(() =>
  import('./MoneyHeaderLayout3').then(module => ({ default: module.MoneyHeaderLayout3 })),
);
const MoneyHeaderLayout4 = React.lazy(() =>
  import('./MoneyHeaderLayout4').then(module => ({ default: module.MoneyHeaderLayout4 })),
);

export interface MoneyLayoutHeaderProps {
  bg_color: string;
  background_image: string;
  button_title?: string;
  button_href?: string;
  campaign?: CallToActionProps;
  description?: string;
  header_layout?: string;
  services?: {
    service_img?: string;
    title: string;
    url: string;
  }[];
  subtitle?: string;
  title: string;
  topics?: Topic[];
  bz_features?: BzFeatures[];
  is_ranking_screener?: boolean;
}

interface Topic {
  topic: string;
}

interface BzFeatures {
  feature_title?: string;
  feature_image?: string;
  feature_description?: string;
}

export const MoneyLayoutHeader = ({
  background_image,
  bg_color,
  button_href,
  button_title,
  bz_features,
  campaign,
  description,
  header_layout = 'layout_1',
  is_ranking_screener = false,
  services,
  subtitle,
  title,
  topics,
}: MoneyLayoutHeaderProps) => {
  return (
    <>
      {(() => {
        if (header_layout === 'layout_1') {
          return (
            <MoneyLayoutHeaderBlockWrapper
              className="money-layout-header-block-wrapper"
              style={{
                backgroundColor: bg_color,
                backgroundImage: `url(${background_image})`,
                backgroundSize: 'contain',
              }}
            >
              <MoneyHeaderLayout1
                button_href={button_href}
                button_title={button_title}
                services={services}
                subtitle={subtitle}
                title={title}
                topics={topics}
              />
            </MoneyLayoutHeaderBlockWrapper>
          );
        } else if (header_layout === 'layout_2') {
          return (
            <MoneyHeaderLayout2
              background_image={background_image}
              bg_color={bg_color}
              button_href={button_href}
              button_title={button_title}
              subtitle={subtitle}
              title={title}
            />
          );
        } else if (header_layout === 'layout_3') {
          return (
            <MoneyLayoutHeaderBlockWrapper className={`money-layout-header-block-wrapper ${header_layout}`}>
              <MoneyHeaderLayout3
                background_image={background_image}
                bg_color={bg_color}
                bz_features={bz_features}
                subtitle={subtitle}
                title={title}
              />
            </MoneyLayoutHeaderBlockWrapper>
          );
        } else if (header_layout === 'layout_4') {
          return (
            <MoneyLayoutHeaderBlockWrapper className={`money-layout-header-block-wrapper ${header_layout}`}>
              <MoneyHeaderLayout4
                background_image={background_image}
                campaign={campaign}
                description={description}
                is_ranking_screener={is_ranking_screener}
                services={services}
                subtitle={subtitle}
                title={title}
              />
            </MoneyLayoutHeaderBlockWrapper>
          );
        } else {
          return <></>;
        }
      })()}
    </>
  );
};

const MoneyLayoutHeaderBlockWrapper = styled.div`
  &.money-layout-header-block-wrapper {
    // position: relative;
    // background-position: top right;
    // background-size: 800px;
    // background-repeat: no-repeat;
    // cursor: default;
    .header-cover {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: -1;
    }
    @media screen and (max-width: 1439px) {
      background-position: top 0 right -240px;
    }

    @media screen and (max-width: 959px) {
      background-position: top 0 right -296px;
    }

    @media screen and (max-width: 767px) {
      background-position: top 0 right -494px;
    }

    .block-content-wrapper {
      max-width: 1100px;
      margin: 0 auto;
      padding: 64px 1rem 0;
      display: flex;
      flex-direction: column;
      gap: 40px;
      @media screen and (max-width: 567px) {
        padding: 20px 14px 0;
      }
    }
    &.layout_4 {
      .block-content-wrapper {
        padding: 0;
      }
    }

    .block-title {
      max-width: 610px;
      font-weight: 700;
      font-size: 64px;
      line-height: 80px;
      color: #ffffff;

      @media screen and (max-width: 567px) {
        font-size: 48px;
        line-height: 56px;
      }
    }
  }
`;
